const initialState = {
  profileData: null,
    token: null,
    loading: false,
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PROFILE':
      return {
        ...state,
        profileData: action.payload,
      };
      case 'SET_TOKEN':
          return {
              ...state,
              token: action.payload,
          };
      case 'SET_LOADING':
          return {
              ...state,
              loading: action.payload,
          };
      case 'CLEAR_STORE':
          // Возвращаем чистый initialState
          return {
              ...initialState,
              authChecked: true, // Устанавливаем authChecked в true после очистки
          };
    default:
      return state;
  }
};

export default rootReducer;